import { PageHeader } from '@organisms';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import BasicInfo from '../components/BasicInfo';
import Permissions from '../components/Permissions';
import UsersProfile from '../components/UsersProfile';

export const RoleScreen: FC = () => {
  const navigate = useNavigate();
  useBreadcrumbs([
    {
      label: 'Permissões',
    },
  ]);

  return (
    <>
      <BasicInfo />
      <UsersProfile />
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={'Permissões'}
        subTitle={''}
      />
      <Permissions />
    </>
  );
};
